import script from "./ParcProfilePosteLivraisonList.vue?vue&type=script&setup=true&lang=js"
export * from "./ParcProfilePosteLivraisonList.vue?vue&type=script&setup=true&lang=js"

import "./ParcProfilePosteLivraisonList.vue?vue&type=style&index=0&id=5438bd90&lang=scss"

const __exports__ = script;

export default __exports__